<template>
    <div class="loader">
        <canvas ref="canvasRef" class="xmas-tree"></canvas>
    </div>
</template>

<style lang="scss">
.xmas-tree {
    width: 25%;
    height: auto;
    outline: none;
}
</style>
